import { IconButton } from '@/shared/ui';
import { XCircleIcon } from 'lucide-react';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { UserResponse } from '@/entities/users';
import { NestedItemCard } from '@/features/nested-items';
import { toUserGroupMember, UserGroupFromValues, UserGroupMemberValue } from '../UsersGroupForm/types';
import { AddUsersDialog } from './AddUsersDialog';
import { UserGroupMemberTitle } from './UserGroupMemberTitle';

const renderUserTitle = (user: UserGroupMemberValue) => <UserGroupMemberTitle user={user} />;

type Props = {
  disabled?: boolean;
};

export const UsersList: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation(['users', 'common']);
  const { setValue, getValues, watch } = useFormContext<UserGroupFromValues>();
  const currentUsers = watch('users');

  // Состав группы — такое же изменение карточки, как правка её поля: без `shouldDirty` кнопка сохранения остаётся неактивной
  const handleSaveDialog = (newUsers: UserResponse[]) => {
    setValue('users', [...(getValues('users') || []), ...newUsers.map(toUserGroupMember)], { shouldDirty: true });
  };

  const handleRemoveUser = (id: number) => {
    setValue('users', getValues('users')?.filter((user) => user.id !== id) || [], { shouldDirty: true });
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-5 items-center">
        <p className="font-medium">{t('users')}</p>

        {!disabled && <AddUsersDialog existingUsers={currentUsers ?? []} onSave={handleSaveDialog} />}
      </div>

      <div className="flex flex-col gap-3">
        {currentUsers?.map((user) => (
          <NestedItemCard
            key={user.id}
            item={user}
            renderTitle={renderUserTitle}
            renderDescription={(item) => item.email}
            action={
              !disabled && (
                <IconButton
                  icon={<XCircleIcon />}
                  variant="ghost"
                  color="destructive"
                  label={t('users:removeUserFromGroup')}
                  onClick={() => handleRemoveUser(user.id)}
                />
              )
            }
          />
        ))}
        {currentUsers?.length === 0 && <p className="text-sm text-muted-foreground">{t('noUsersInGroup')}</p>}
      </div>
    </div>
  );
};
